import { render } from "./application_position.vue?vue&type=template&id=524064fc&scoped=true"
import script from "./application_position.vue?vue&type=script&lang=js"
export * from "./application_position.vue?vue&type=script&lang=js"

import "./application_position.vue?vue&type=style&index=0&id=524064fc&scoped=true&lang=css"

import exportComponent from "/var/www/host/imc/tender/dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-524064fc"],['__file',"vue/js/components/sale/applications/inside/blocks/application_position.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "524064fc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('524064fc', __exports__)) {
    console.log('reload')
    api.reload('524064fc', __exports__)
  }
  
  module.hot.accept("./application_position.vue?vue&type=template&id=524064fc&scoped=true", () => {
    console.log('re-render')
    api.rerender('524064fc', render)
  })

}


export default __exports__